import React, {useState} from 'react';
import './Vault.scss';
import * as _ from "lodash";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Tooltip from "@material-ui/core/Tooltip";
import * as moment from "moment";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";

const MINOR_EVENTS = ['DOCUMENT_DOWNLOADED', 'KEYHOLDERS_ADDED', 'KEYHOLDERS_REMOVED', 'GUARDIANS_ADDED',
  'GUARDIANS_REMOVED', 'DOCUMENTS_ADDED', 'DOCUMENTS_REMOVED', 'GUARDIAN_APPROVED_REQUEST', 'GUARDIAN_DENIED_REQUEST',
  'KEYHOLDER_APPROVED_REQUEST', 'KEYHOLDER_DENIED_REQUEST', 'OWNER_APPROVED_REQUEST', 'OWNER_DENIED_REQUEST',]

function VaultActivity(props) {
  let [showAll, setShowAll] = useState(false);
  let [hideMinor, setHideMinor] = useState(false);

  let activityLog = [];
  props.vault.activity_log.forEach((activity) => activityLog.unshift(activity)); // no idea why _.reverse doesn't work here
  if (hideMinor) {
    activityLog = _.filter(activityLog, (activity) => {return !_.includes(MINOR_EVENTS, activity.type)});
  }

  const getActivityRow = (activity) => {
    let icon = '';
    let title = '';
    let iconColor = 'text-grey';

    switch(activity.type){
      case "VAULT_CREATED":
        icon = 'folder-plus';
        title = 'Vault Created';
        iconColor = 'text-primary';
        break;
      case "ACCESS_REQUESTED":
        icon = 'key';
        title = 'Access Requested';
        iconColor = 'text-warning';
        break;
      case "ACCESS_REQUEST_APPROVED":
        icon = 'check';
        title = 'Access Request Approved';
        iconColor = 'text-primary';
        break;
      case "ACCESS_REQUEST_DENIED":
        icon = 'times';
        title = 'Access Request Denied';
        iconColor = 'text-alert';
        break;
      case "ACCESS_REQUEST_CANCELLED":
        icon = 'times';
        title = 'Access Request Cancelled';
        iconColor = 'text-alert';
        break;
      case "VAULT_LOCKED":
        icon = 'lock';
        title = 'Vault Locked';
        iconColor = 'text-alert';
        break;
      case "VAULT_ARCHIVED":
        icon = 'box';
        title = 'Vault Archived';
        break;
      case "VAULT_UNARCHIVED":
        icon = 'box-open';
        title = 'Vault Un-archived';
        break;
      case "GUARDIAN_APPROVED_REQUEST":
        icon = 'check';
        title = 'Guardian Approved Request';
        iconColor = 'text-primary';
        break;
      case "GUARDIAN_DENIED_REQUEST":
        icon = 'times';
        title = 'Guardian Denied Request';
        iconColor = 'text-alert';
        break;
      case "DOCUMENT_DOWNLOADED":
        icon = 'file-download';
        title = 'Document Downloaded';
        break;
      case "KEYHOLDERS_ADDED":
        icon = 'user-check';
        title = 'Keyholder(s) Added';
        break;
      case "KEYHOLDERS_REMOVED":
        icon = 'user-times';
        title = 'Keyholder(s) Removed';
        break;
      case "GUARDIANS_ADDED":
        icon = 'user-check';
        title = 'Guardian(s) Added';
        break;
      case "GUARDIANS_REMOVED":
        icon = 'user-times';
        title = 'Guardian(s) Removed';
        break;
      case "DOCUMENTS_ADDED":
        icon = 'file-upload';
        title = 'New File(s) Added.';
        break;
      case "DOCUMENTS_REMOVED":
        icon = 'trash';
        title = 'File(s) Removed';
        break;
      case "OWNER_APPROVED_REQUEST":
        icon = 'check';
        title = 'Owner Approved Request';
        iconColor = 'text-primary';
        break;
      case "OWNER_DENIED_REQUEST":
        icon = 'times';
        title = 'Owner Denied Request';
        iconColor = 'text-alert';
        break;
    }

    return <>
      <div className="activity-type-field">
        <div className="flex items-center">
          <FontAwesomeIcon icon={icon} className={`mr-2 ${iconColor}`}/>
          <p>{ title }</p>
        </div>
        {
          activity.additional_details &&
            <div className="text-sm text-grey mt-2">{ typeof activity.additional_details === 'object'
              ? _.map(activity.additional_details, (detail, index) => <div key={index} className="pl-4 activity-additional-detail-text">–&nbsp;{detail}<br/></div>)
              : <div className="pl-4 activity-additional-detail-text">–&nbsp;{activity.additional_details}</div>}
            </div>
        }
      </div>
      <Tooltip enterTouchDelay={50} title={activity.user === 'SYSTEM' ?
        'This event was generated by the Fidelius System in response to user activity.' :
        <div>
          <p>Role: {activity.user.role}</p>
          <p>Email: {activity.user.email}</p>
        </div> }>
        <p className="activity-user-field  text-ellipsis text-sm cursor-pointer h-full pl-4 sm:pl-0 mb-1 mt-2 sm:mt-0 sm:mb-0">{ activity.user === 'SYSTEM' ? 'System' : activity.user.name }</p>
      </Tooltip>
      <p className="activity-date-field text-grey text-sm pl-4 sm:pl-0">{ moment(activity.created).format('L LT') }</p>
    </>
  }

  return (
    <div className="vault-details-container mx-auto text-sm sm:text-base">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3">
        <p className="text-xl"><b className="medium-text-xl">{ activityLog.length }</b> Event{ activityLog.length !== 1 ? 's' : '' } </p>
        <div>
          <span className="text-sm right-spacer-small">Hide Minor Events</span>
          <Checkbox
            checked={hideMinor}
            onChange={(event, checked) => setHideMinor(checked)}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
        </div>
      </div>
      <div className="vault-form-content-container">

        {
          _.map(showAll ? activityLog : _.take(activityLog, 5), (activity, index) =>
            <div key={index} className={`vault-detail-table-row ${index % 2 ? '' : 'alternate'} flex flex-col sm:flex-row sm:items-center`}>
              { getActivityRow(activity) }
            </div>
          )
        }
        {
          activityLog.length > 5 &&
            <div className="flex center-xs middle-xs top-spacer-medium">
              <Button onClick={() => setShowAll(!showAll)}>
                <span className="flex items-center text-grey">
                  {showAll ? 'Hide' : 'Show More'}
                  <FontAwesomeIcon icon={showAll ? 'caret-up' : 'caret-down'} className="ml-2"/>
                </span>
              </Button>
            </div>
        }
      </div>
    </div>  );
};

export default VaultActivity;

